import { render } from "./P2PSetting.vue?vue&type=template&id=08f4fd36&scoped=true"
import script from "./P2PSetting.vue?vue&type=script&lang=js"
export * from "./P2PSetting.vue?vue&type=script&lang=js"

import "./P2PSetting.vue?vue&type=style&index=0&id=08f4fd36&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f4fd36"]])

export default __exports__